import React from 'react'
import * as Styles from './SearchInput.style'
import { Context } from '../HomeSearchPage'
import { trim } from '../../../../../utils/tools'
import { withRouter, RouterProps } from 'react-router'
export const SearchInput = withRouter((props: RouterProps) => {
    const [type, setType] = React.useState<string>('')
    const [specialType, setSpecialType] = React.useState<boolean>(false)
    const searchInputRef = React.useRef<HTMLInputElement>()
    const [placeholder, setPlaceholder] = React.useState<string>('')
    const serachContext = React.useContext(Context)

    React.useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus()
            if (serachContext.state && serachContext.state.form_data) {
                const store = serachContext.state
                setPlaceholder(store.form_data.word)
                setSpecialType(true)
            } else {
                setPlaceholder('搜索课程/专栏/直播间')
            }
            document.addEventListener('keydown', () => listenType(event))
        }
        return () => {
            document.removeEventListener('keydown', () => listenType(event))
        }
    }, [])

    const userTypeEmptyContent = () => {
        if (searchInputRef.current) {
            if (trim(searchInputRef.current.value).length === 0 && searchInputRef.current.value.length > 0) {
                return true
            } else {
                return false
            }
        }
    }

   // 跳转搜索结果页
    const toSearchResult = (value: string, ItemType = 'normal') => {

        if (!specialType && (userTypeEmptyContent() || value === '')) { // 如果啥都没输入
            return
        }

        if (value !== '' && ItemType !== 'special' && !userTypeEmptyContent()) {
            serachContext.dispatch({
                type: 'SET_SEARCH_HISTORY',
                payload: {value, ItemType, url: value}
            })
            setTimeout(() => {
                let keyword = value
                try {
                    keyword = encodeURIComponent(value)
                } catch (error) {
                    keyword = value
                }
                props.history.push(`/search-result?keyword=${keyword}`)
                // window.location.assign(`https://m.lizhiweike.com/search?q=${value}`)
            } , 0)
        } else {
            if (searchInputRef.current) {
                const url = serachContext.state.form_data.link
                serachContext.dispatch({
                    type: 'SET_SEARCH_HISTORY',
                    payload: {value: searchInputRef.current.placeholder, ItemType: 'special', url}
                })
                window.location.assign(url)
            }
        }
    }

    // 监听用户按下enter键，搜索用
    const listenType = (event) => {
        const e = event || window.event
        if (e && e.keyCode === 13) {
            if (!searchInputRef.current) {
                return
            }
            if (searchInputRef.current.value !== '' && !userTypeEmptyContent()) {
                toSearchResult(searchInputRef.current.value)
            } else {
                toSearchResult(searchInputRef.current.placeholder, 'special')
            }
        }
    }

    // 记录用户输入值
    const typeValue = (e) => {
        setType(e.target.value)
    }

    const deleteTypeText = () => {
        setType('')
    }

    return (
        <div className={Styles.SearchWrap}>
            <form  className={Styles.SearchPageInputWrap} action="javascript:void(0)">
                <input type="search" ref={searchInputRef} className={Styles.SearchPageInput} onChange={(e) => typeValue(e)} placeholder={placeholder} value={type}/>
                {type.length > 0 && <span onClick={() => deleteTypeText()} className={Styles.deleteTypeText}><img src="https://static-1253442168.image.myqcloud.com/picture/11285307_4bc3220afc06392183c8492e2207344f.jpg" alt=""/></span>}
            </form>
            <button className={Styles.searchBtn} onClick={() => toSearchResult(type)}>搜索</button>
        </div>
    )
}
)



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/SearchInput/SearchInput.tsx